"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../constants");

var _app = require("../../store/reducers/app");

var _app2 = require("../../store/selectors/app");

var _util = require("../../util");

var _ImageWithFalback = _interopRequireDefault(require("../ImageWithFalback"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AgentWelcome =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AgentWelcome, _PureComponent);

  function AgentWelcome() {
    _classCallCheck(this, AgentWelcome);

    return _possibleConstructorReturn(this, _getPrototypeOf(AgentWelcome).apply(this, arguments));
  }

  _createClass(AgentWelcome, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appEnv = _this$props.appEnv,
          items = _this$props.items,
          type = _this$props.type;
      var item = items[0];
      var agentName = item && item.nickname || this.props.intl.formatMessage({
        id: 'Support:HelpBot:LiveEngage:DefaultAgentName'
      });
      var avatarImageSrc = item && item.pictureUrl || '';
      var welcomeMessageId;

      switch (type) {
        case _constants.CONVERSATION_TYPE_TEXT_HUMAN_JOIN:
          welcomeMessageId = 'Support:HelpBot:LiveEngage:JoinedChat';
          break;

        case _constants.CONVERSATION_TYPE_TEXT_HUMAN_START:
          welcomeMessageId = 'Support:HelpBot:LiveEngage:ChattingWith';
          break;

        default:
          // eslint-disable-next-line no-console
          console.error('Invalid type specified for AgentWelcome component');
      }

      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "jsx-826702697" + " " + 'live-agent-display-container'
      }, _react["default"].createElement("div", {
        className: "jsx-826702697" + " " + 'agent-display-text'
      }, welcomeMessageId && _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: welcomeMessageId,
        values: {
          agentName: agentName
        }
      })), _react["default"].createElement("div", {
        className: "jsx-826702697" + " " + 'live-agent-icon-intro'
      }, _react["default"].createElement(_ImageWithFalback["default"], {
        src: avatarImageSrc,
        fallback: "".concat((0, _util.getCdnPath)(appEnv), "/images/godaddy-guides-faces.jpg"),
        alt: "",
        style: {
          borderRadius: '50%'
        }
      }))), _react["default"].createElement(_style["default"], {
        id: "826702697"
      }, ".live-agent-display-container.jsx-826702697{margin-bottom:24px;text-align:center;}.live-agent-icon-intro.jsx-826702697{height:74px;margin:0 auto;margin-top:16px;width:74px;}"));
    }
  }]);

  return AgentWelcome;
}(_react.PureComponent);

AgentWelcome.propTypes = {
  appEnv: _app.appPropTypes.env,
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  intl: _reactIntl.intlShape,
  type: _propTypes["default"].string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appEnv: (0, _app2.getAppEnv)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(AgentWelcome));

exports["default"] = _default;